import React from 'react';
import { HtmlMagnification, IHtmlViewerRef } from './HtmlMagnification';
import { FitType, IFormInteractionHandler } from './IFormInteractionHandler';

export class HtmlFormInteractionHandler implements IFormInteractionHandler {
    constructor(private htmlViewer: React.RefObject<IHtmlViewerRef | null>) {}

    private get magnification(): HtmlMagnification | undefined {
        return this.htmlViewer.current?.magnification;
    }

    getCurrentPage(): number {
        return 1;
    }

    getTotalPages(): number {
        return 1;
    }

    goToPage(_: number): void {}

    goToPreviousPage(): void {}

    goToNextPage(): void {}

    goToFirstPage(): void {}

    goToLastPage(): void {}

    zoomIn(): number {
        return this.magnification?.zoomIn() ?? 1;
    }

    zoomOut(): number {
        return this.magnification?.zoomOut() ?? 1;
    }

    zoomTo(zoomPercentage: number): void {
        this.magnification?.zoomTo(zoomPercentage);
    }

    fitToPage(): void {
        this.magnification?.fitToPage();
    }

    fitToWidth(): void {
        this.magnification?.fitToWidth();
    }

    fitToAuto(): void {
        this.magnification?.fitToAuto();
    }

    getCurrentFitType(): FitType {
        return this.magnification?.getCurrentFitType() ?? null;
    }
}
